import {
  ProgressLayoutSkeleton,
  SuspensePageBoundary,
} from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { WordReferenceLearningProgressScreenSuspense } from "#word-reference-learning-progress-screen-suspense";

export function WordReferenceLearningProgressScreen({ word }: { word: string }) {
  return (
    <SuspensePageBoundary fallback={<ProgressLayoutSkeleton />} location={import.meta.location}>
      <WordReferenceLearningProgressScreenSuspense word={word} />
    </SuspensePageBoundary>
  );
}
